import { forwardRef, type InputHTMLAttributes } from 'react';

import styles from './Checkbox.module.css';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'style' | 'type'>;

/** Represents a checkbox component. */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ ...restProps }: CheckboxProps, Ref) => (
  <input {...restProps} type="checkbox" className={styles['checkbox']} ref={Ref} />
));
